/**
 * LO QUE EL DASHBOARD PIDE Y SE PUEDE REUSAR AL VOLVER (PANEL-CARGA-EFICIENCIA-T1, Ares #26782): conteos, la tabla NXS,
 * las tarjetas del mes, el Como nos fue (es de ayer) y los KPIs de la semana. 30 s: volver de otra vista no los pide
 * otra vez; pasado ese rato se piden de nuevo. NO entran las aprobaciones pendientes ni la asistencia de hoy: esas
 * cambian mientras el dueno mira. Guardar cualquier cosa borra todo lo reusado (ApiBase).
 */
export const REUSO_DASHBOARD_MS = 30000;
export const RUTAS_REUSO_DASHBOARD = [
  /^\/api\/v1\/Tasks\/statistics$/,
  /^\/api\/v1\/Tasks\?page=1&pageSize=1&status=[a-z_]+$/,
  /^\/api\/v1\/(Instructions|Users|Agents)\?page=1&pageSize=1$/,
  /^\/api\/v1\/Projects\?page=1&pageSize=50$/,
  /^\/api\/v1\/(Instructions|Projects)\?page=1&pageSize=1&status=active$/,
  /^\/api\/v1\/Missions\?page=1&pageSize=\d+(&status=[a-z_]+)?$/,
  /^\/api\/v1\/license\/clients$/,
  /^\/api\/v1\/learning\/(questions\?limit=100&random=false|skills|skills\/progress)$/,
  /^\/api\/businesses\/all$/,
  /^\/api\/v1\/negocios\/[^/]+\/indicadores-mes\?mes=\d{4}-\d{2}$/,
  /^\/api\/v1\/negocios\/[^/]+\/capacidades\/reporte\.como_nos_fue_hoy\?periodo=\d{4}-\d{2}-\d{2}$/,
  /^\/api\/sync\/ordenes\?businessId=[^&]+&pageSize=500$/,
  /^\/api\/sync\/verificacion_inventario\?businessId=[^&]+&pageSize=300$/
];

export function reglasDeReusoDelDashboard() {
  return RUTAS_REUSO_DASHBOARD.map((patron) => ({ patron, ms: REUSO_DASHBOARD_MS }));
}
